import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import colors from 'vuetify/lib/util/colors'

// WoB custom SVG icons (naming follows package convention: Wob{Category}{Variant})
import {
  WobDamperAlarm,
  WobDamperOpenclose,
  WobDamperPosition,
  WobDamperStatus,
  WobFanSpeed,
  WobFanStartstop,
  WobFanStatus,
  WobHeatwheel,
  WobHeatwheelAlarm,
  WobHeatwheelSpeed,
  WobHeatwheelStartstop,
  WobHeatwheelStatus,
  WobPumpAlarm,
  WobPumpSpeed,
  WobPumpStartstop,
  WobPumpStatus,
  WobValveAlarm,
  WobValveOpenclose,
  WobValvePosition,
  WobValveStatus,
  WobRealestate,
} from '@wobscandinavia/wob-icons'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    values: {
      // Real Estate
      'wob-realestate': { component: WobRealestate },
      // Damper
      'wob-damper': { component: WobDamperStatus },
      'wob-damper-alarm': { component: WobDamperAlarm },
      'wob-damper-openclose': { component: WobDamperOpenclose },
      'wob-damper-position': { component: WobDamperPosition },
      'wob-damper-status': { component: WobDamperStatus },
      // Fan
      'wob-fan': { component: WobFanStatus },
      'wob-fan-speed': { component: WobFanSpeed },
      'wob-fan-startstop': { component: WobFanStartstop },
      'wob-fan-status': { component: WobFanStatus },
      // Heatwheel
      'wob-heatwheel': { component: WobHeatwheel },
      'wob-heatwheel-alarm': { component: WobHeatwheelAlarm },
      'wob-heatwheel-speed': { component: WobHeatwheelSpeed },
      'wob-heatwheel-startstop': { component: WobHeatwheelStartstop },
      'wob-heatwheel-status': { component: WobHeatwheelStatus },
      // Pump
      'wob-pump': { component: WobPumpStatus },
      'wob-pump-alarm': { component: WobPumpAlarm },
      'wob-pump-speed': { component: WobPumpSpeed },
      'wob-pump-startstop': { component: WobPumpStartstop },
      'wob-pump-status': { component: WobPumpStatus },
      // Valve
      'wob-valve': { component: WobValveStatus },
      'wob-valve-alarm': { component: WobValveAlarm },
      'wob-valve-openclose': { component: WobValveOpenclose },
      'wob-valve-position': { component: WobValvePosition },
      'wob-valve-status': { component: WobValveStatus },
    },
  },
  theme: {
    themes: {
      light: {
        primary: colors.blueGrey.darken2,
        secondary: colors.lime.darken2,
        error: colors.red.darken4,
        accent: colors.blueGrey.darken2,
      },
    },
  },
})
